/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Autocomplete,
  Chip,
  Grid,
  TextField,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { WorkflowModel } from "../../Utils/Models";
import { Vocabulary } from "../../Utils/Vocabulary";
import { TextValidator } from "react-material-ui-form-validator";
import {
  handleChangeAutocomplete,
  onChangeTextField,
} from "../../Utils/Utils";
import useCustomMemo from "../GenericComponents/useCustomMemo";

type WorkflowProps = {
  workflow: WorkflowModel;
  subWorkflows: WorkflowModel[];
  workflows: WorkflowModel[];
  handleChangeWorkflow: (workflow: WorkflowModel) => void;
  changeSubWorkflows: (
    event: any,
    value: any,
    parentId: string | null,
    subWorkflows: any
  ) => void;
};
export default function Workflow(props: WorkflowProps) {
  const {
    workflow,
    workflows,
    subWorkflows,
    handleChangeWorkflow,
    changeSubWorkflows,
  } = props;
  const cache = useCustomMemo();
  const statuses =
    cache.statuses.filter((status: any) => !status.workflowId) || [];

  const phoneStyle = useMediaQuery("(min-width: 381px) and (max-width: 450px)");
  const miniPhoneStyle = useMediaQuery("(max-width: 380px)");

  return (
    <Grid container spacing={2} style={{ marginTop: 10 }}>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextValidator
          variant="outlined"
          label={Vocabulary.name}
          value={workflow.name || ""}
          fullWidth
          size="small"
          id={"name"}
          name="name"
          onChange={(event) =>
            handleChangeWorkflow(onChangeTextField(event, workflow))
          }
        />
      </Grid>
      <Grid item xs={12} sm={12} md={6} lg={6}>
        <TextValidator
          variant="outlined"
          label={Vocabulary.description}
          value={workflow.description || ""}
          fullWidth
          size="small"
          id={"description"}
          name="description"
          onChange={(event) =>
            handleChangeWorkflow(onChangeTextField(event, workflow))
          }
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12}>
        <Autocomplete
          size="small"
          id={"statuses"}
          multiple
          freeSolo={false}
          disablePortal
          options={statuses}
          value={workflow.statuses || []}
          getOptionLabel={(option: any) => option.name}
          isOptionEqualToValue={(option, value) => option.name === value.name}
          getOptionDisabled={(option) =>
            !!(
              workflow.statuses &&
              workflow.statuses.find(
                (element: any) => element.name === option.name
              )
            )
          }
          style={
            phoneStyle
              ? { maxWidth: "330px" }
              : miniPhoneStyle
              ? { maxWidth: "300px" }
              : {}
          }
          onChange={(event: any, value: any) =>
            handleChangeWorkflow(
              handleChangeAutocomplete(event, value, workflow, "statuses")
            )
          }
          renderInput={(params: any) => (
            <TextField
              {...params}
              fullWidth
              size="small"
              label={Vocabulary.statuses}
              variant="outlined"
            />
          )}
        />
      </Grid>

      {/* parent for subWorkflow */}
      <Grid item xs={12} sm={12} md={12} lg={12}>
        {workflow?.parentId ? (
          <>
            <Typography variant="h6">{Vocabulary.workflowParent}</Typography>
            <Chip
              label={
                workflows.find(
                  (element: any) => element._id === workflow?.parentId
                )?.name
              }
              color="primary"
              style={{
                fontSize: 16,
              }}
            />
            <br />
          </>
        ) : null}
      </Grid>
      {/* end parent for subWorkflow */}

      {/* subWorkflows */}
      <Grid item xs={12} sm={12} md={12} lg={12}>
        {workflow?._id ? (
          <>
            <Typography variant="h6" style={{ marginLeft: 5 }}>
              {Vocabulary.selectSubWorkflows}:
            </Typography>
            <Autocomplete
              size="small"
              id={"subWorkflows"}
              multiple
              freeSolo={false}
              disablePortal
              options={workflows}
              value={subWorkflows || []}
              getOptionLabel={(option: any) => option.name}
              isOptionEqualToValue={(option, value) =>
                option.name === value.name
              }
              getOptionDisabled={(option) =>
                !!(
                  subWorkflows &&
                  [...subWorkflows, workflow].find(
                    (element: any) => element._id === option._id
                  )
                )
              }
              onChange={(event: any, value: any) =>
                changeSubWorkflows(
                  event,
                  value,
                  workflow?._id || null,
                  subWorkflows
                )
              }
              renderInput={(params: any) => (
                <TextField
                  {...params}
                  fullWidth
                  size="small"
                  label={Vocabulary.subWorkflows}
                  variant="outlined"
                />
              )}
            />
          </>
        ) : null}
      </Grid>
      {/* end subWorkflows */}
    </Grid>
  );
}
